import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Landing from './pages/landing/landing';
import About from './pages/about/about';

const Routes = () => (
  <Router>
    <Switch>
      <Route path="/about" component={About} exact />
      <Route path="/" component={Landing} />
    </Switch>
  </Router>
);

export default Routes;
